export default __webpack_public_path__ + "static/media/43k.63fed06c.md";